;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import React, { Fragment } from "react"
const descriptionWithNewLines = (description, keyPrefix) => {
  if (typeof description !== "string") {
    return description
  }
  return description.split("\n").map((line, index, array) => {
    return index === array.length - 1 ? (
      line
    ) : (
      <Fragment key={`${keyPrefix}-${index}`}>
        {line}
        <br />
      </Fragment>
    )
  })
}

export default descriptionWithNewLines
